import { Instance } from 'mobx-state-tree';
import { OrderTagDtoModelBase } from './OrderTagDtoModel.base';

/* The TypeScript type of an instance of OrderTagDtoModel */
export interface OrderTagDtoModelType extends Instance<typeof OrderTagDtoModel.Type> {}

/* A graphql query fragment builders for OrderTagDtoModel */
export { selectFromOrderTagDto, orderTagDtoModelPrimitives, OrderTagDtoModelSelector } from './OrderTagDtoModel.base';

/**
 * OrderTagDtoModel
 */
export const OrderTagDtoModel = OrderTagDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
